import { WeightModeEnum } from '@api/ringil-api.v2';
import { OrderItemViewData } from '@components/obsolete/customer/new-expedition/types';

export const calculateOrderWeight = (orderItem: OrderItemViewData) =>
  orderItem.weightMode === WeightModeEnum.TOTAL_WEIGHT ? orderItem.weight : orderItem.weight * orderItem.amount;

